import { Component, EventEmitter, Inject, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackbarService } from '../../../services/snackbar.service';
import { SpinnerService } from '../../../services/spinner.service';
import { Router } from '@angular/router';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import {
  CodigoOperacionControllerService,
  CodigoOperacionFilterDTO,
  OperacionGestionControllerService,
  PoseedorControllerService,
  PoseedorDTO,
  ResiduoEnvaseControllerService,
  ResiduoEnvasePayloadDTO
} from 'api-rest';
import { ValidateService } from '../../../services/validate.service';
import { map, catchError, of, zip } from 'rxjs';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-holders-waste-forecast-duplicate-dialog',
  templateUrl: './holders-waste-forecast-duplicate-dialog.component.html',
  styleUrls: ['./holders-waste-forecast-duplicate-dialog.component.scss'],
})
export class HoldersWasteForecastDuplicateDialogComponent implements OnInit {
  @Input() poseedorInfo!: PoseedorDTO | any;
    @Output() public refrescarPoseedorEvent = new EventEmitter<any>();
  
    formGroup!: FormGroup;
    tiposCodigosLer: any[] = [];
    operacionesGestion: any[] = [];
    suministraInfoList = [
      { id: 'Gestor', name: 'Gestor' },
      { id: 'Poseedor', name: 'Poseedor' },
    ];
    anios: any[] = [];
    codigosLerEndpoint =
      this.environment.urlBackCore + 'api/v1/core/codigo-ler/filtro-combo?poseedores=true';
    updateList: boolean = false;
    updateListOpera: boolean = false;
    flagDisabledForm: boolean = false;
    anioActual!: number;
    nimaAsignadoEnvalora:string = '9999999999';
    grid: any[] = [];
  
    pageNumber: number = 0;
    pageSize: number = 100;
    recordsTotal: number = 0;
    gestionArray: any[] = [];
    savingData:boolean = false;
  
    headArray: any[] = [
      {
        Head: 'Año',
        FieldName: 'anioDatos',
      },
      {
        Head: 'Código LER y descripción de ENVALORA',
        FieldName: 'descripcionMCodLer',
        Tooltip: true,
      },
      {
        Head: 'Operación gestión específica',
        FieldName: 'operacionMGestion',
        Tooltip: true,
      },
      {
        Head: '',
        FieldName: 'actions',
        buttons: [
          {
            nameButton: 'warning',
            icon: 'warning',
            toolTip:
              'NIMA de gestor no existe en la base de datos de gestores de ENVALORA',
            show: (row: any) => this.showWarning(row),
          },
        ],
      },
      {
        Head: 'NIMA del gestor',
        FieldName: 'nimaGestor',
      },
      {
        Head: 'Previsión cantidad anual generada (Kg)',
        FieldName: 'previsionCantidadGenerada',
      },
      {
        Head: '¿Quién suministra información de gestión?',
        FieldName: 'suministradorInformacion',
      },
      {
        Head: 'Acciones',
        FieldName: 'actions',
        buttons: [
          {
            nameButton: 'delete',
            icon: 'delete',
            toolTip: 'Borrar',
            show: { params: 'canAccessDelete', accion: 'delete' },
          },
                  {
            nameButton: 'edit',
            icon: 'edit',
            toolTip: 'Editar',
            show: { params: 'canAccessEdit', accion: 'edit' },
          },
          {
            nameButton: 'duplicate',
            icon: 'file_copy',
            toolTip: 'Duplicar',
            show: { params: 'canAccessDuplicate', accion: 'duplicate' },
          },
        ],
        width: '2',
        permanent: true,
      },
    ];
    label: string = 'Añadir previsión';
    constructor(
      private formBuilder: FormBuilder,
      @Inject('environment') private environment: any,
      public spinnerSrv: SpinnerService,
      private snackBarSrv: SnackbarService,
      private poseedorControllerSrv: PoseedorControllerService,
      private validateSrv: ValidateService,
      private router: Router,
      @Inject('EmpusaAuthenticationService')
      private authService: EmpusaAuthenticationService,
      private residuoEnvaseControllerSrv: ResiduoEnvaseControllerService,
      private codigoOperacionControllerService: CodigoOperacionControllerService,
      private operacionGestionControllerService: OperacionGestionControllerService,
        @Inject(MAT_DIALOG_DATA) public data: { prevision: any, duplicar?: boolean, editar?: boolean, nueva?: boolean, poseedorInfo?: PoseedorDTO,previsiones:any },
    public dialogRef: MatDialogRef<HoldersWasteForecastDuplicateDialogComponent>,
    ) {
      this.formGroup = this.formBuilder.group({
        anio: [
          { value: this.data.prevision ? this.data.prevision?.anioDatos : null, disabled: this.data.editar ? true : false },
          { validators: Validators.compose([Validators.required]) },
        ],
        codigoLer: [
          { value: this.data.prevision ? this.data.prevision?.codigoLer : null, disabled: false },    { validators: Validators.compose([Validators.required]) },
        ],
        operacionGestion: [{ value: this.data.prevision ? this.data.prevision?.operacionGestion : null, disabled: false },   { validators: Validators.compose([Validators.required]) },],
        previsionAnual: [
          { value: this.data.prevision ? this.data.prevision?.previsionCantidadGenerada : null, disabled: false },
          {
            validators: Validators.compose([
              Validators.pattern(this.validateSrv.twoDecimals),
              Validators.compose([Validators.required])
            ]),
          },
        ],
        nima: [
          { value: this.data.prevision ? this.data.prevision?.nimaGestor : null, disabled: false },
          {
            validators: Validators.compose([
              Validators.pattern(this.validateSrv.nimaPattern),
              Validators.maxLength(10),
              Validators.compose([Validators.required])
            ]),
          },
        ],
        suministraInfo: [
          { value: this.data.prevision ? this.data.prevision?.suministradorInformacion : null, disabled: false },
          { validators: Validators.compose([Validators.required]) },
        ],
      });
    }
    ngOnInit(): void {
      this.anioActual = new Date().getFullYear();
      const limiteInferior = 2026;
      for (let i = this.anioActual; i <= this.anioActual + 1; i++) {
        if (i >= limiteInferior) {
          this.anios.push({ id: i });
        }
      }

      if (this.data.editar) {
        this.label = 'Editar previsión';
      } else if (this.data.duplicar) {
        this.label = 'Duplicar previsión';
      } else {
        this.label = 'Añadir previsión';
      }

      if (this.data.prevision?.anioDatos) {
        if (this.data.prevision.anioDatos < this.anioActual) {
          this.formGroup.get('anio')?.setValue(null);
        } else {
          this.formGroup.get('anio')?.setValue(this.data.prevision.anioDatos);
        }
      } else {
         this.formGroup.get('anio')?.setValue(this.anioActual === 2024 ? 2025 : this.anioActual);
      }

      if (this.data.prevision?.codigoLer) {
        this.formGroup.get('codigoLer')?.setValue(this.data.prevision.codigoLer);
      }
      
      this.valueChangeCodigoLer();
      this.grid = this.data.previsiones;
      this.anioSelected();
    }
  
    valueChangeCodigoLer() {
      this.formGroup.get('codigoLer')?.valueChanges.subscribe((value: any) => {
        if (value) {
          this.buscarOperacionesGestion();
        } else {
          this.gestionArray = [];
        }
      });
      // Handle initial value if it exists (e.g. when duplicating/ing)
      if (this.formGroup.get('codigoLer')?.value) {
        this.buscarOperacionesGestion();
      }
    }
  
    buscarOperacionesGestion() {
      const { backendFilter, page, size } = this.getBackendFilter();
      this.spinnerSrv.loadingShow();
      this.codigoOperacionControllerService
        .findAll12(backendFilter, { page: page, size: size })
        .subscribe({
          next: (res) => {
            this.spinnerSrv.loadingHide();
            if (res) {
              this.gestionArray = res?.datos ?? [];
            }
          },
          error: () => {
            this.spinnerSrv.loadingHide();
          },
        });
    }
  
    private getBackendFilter() {
      const backendFilter: CodigoOperacionFilterDTO = {
        codigoLer: [this.formGroup.get('codigoLer')?.value?.id],
        poseedores: true
      };
      const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
  
      return { backendFilter, page, size: this.pageSize };
    }
  
    ngOnChanges(changes: SimpleChanges): void {
      if (this.data.poseedorInfo) {
        const isReadOnly = this.data.poseedorInfo?.estado?.id === 5;
        this.flagDisabledForm = isReadOnly;
        if (isReadOnly) {
          this.formGroup.disable();
        } else {
          this.formGroup.enable();
        }
        this.grid = this.data.previsiones;
        //this.anioSelected();
      }
    }
    getLerDescription(ler: any) {
      if (!ler || (!ler.tipoCodigo && !ler.descripcion && !ler.id)) return '';
      return (ler.tipoCodigo ?? '') + ' - ' + (ler.descripcion ?? '');
    }
  
    getOperacionDescription(op: any) {
      return op?.descripcion || '';
    }

    compareOperacionGestion(o1: any, o2: any): boolean {
      return o1 && o2 ? o1.id === o2.id : o1 === o2;
    }

    getFormControl(selectForm: any): FormControl {
      switch (selectForm) {
        case 'codigoLer': {
          return this.formGroup.get('codigoLer') as FormControl;
          break;
        }
        case 'operacionGestion': {
          return this.formGroup.get('operacionGestion') as FormControl;
          break;
        }
        default: {
          return this.formGroup.get('') as FormControl;
          break;
        }
      }
    }
    getObjectQuery(searchterm: string) {
      return {
        descripcion: searchterm
      };
    }
  
    public rightHolder(controlName: string) {
      let cl2 = '';
      if (
        (this.formGroup.controls[controlName]?.touched ||
          this.formGroup.controls[controlName]?.dirty) &&
        this.formGroup.controls[controlName]?.errors
      ) {
        cl2 = 'error-focus-input';
      } else {
        cl2 = 'success-focus-input';
      }
      return `${cl2}`;
    }
    selPaginatorHasError(controlName: string) {
      if (
        (this.formGroup.controls[controlName]?.touched ||
          this.formGroup.controls[controlName]?.dirty) &&
        this.formGroup.controls[controlName]?.errors
      ) {
        return true;
      } else {
        return false;
      }
    }
  
    controlHasError(controlName: string, errorName: string) {
      return (
        this.formGroup.controls[controlName].hasError(errorName) &&
        this.formGroup.controls[controlName].touched
      );
    }
    addPrevision(): void {
      if (!this.canAccessCreate()) {
        return;
      }
  
      if (this.formGroup.invalid) {
        this.formGroup.markAllAsTouched();
        this.snackBarSrv.showSnackBar(
          'Revisar los errores en los campos ',
          'error'
        );
        return;
      }
      if (this.data.nueva || this.data.duplicar) {
      if(!this.savingData){
        this.savingData = true;
        if(!this.validarDatosNimaPrefijado()){
          this.savingData = false;
          return;
        }
        const existe = this.grid.find(
          (x) =>
            x.anioDatos === this.formGroup.get('anio')?.value &&
            x.codigoLer?.id === this.formGroup.get('codigoLer')?.value?.id &&
            x.operacionGestion?.id ===
              this.formGroup.get('operacionGestion')?.value?.id &&
            x.nimaGestor === this.formGroup.get('nima')?.value &&
            x.previsionCantidadGenerada ==
              this.formGroup.get('previsionAnual')?.value &&
            x.suministradorInformacion ===
              this.formGroup.get('suministraInfo')?.value
        );
        if (existe) {
          this.snackBarSrv.showSnackBar(
            'Ya existe la previsión de residuos de envases introducida',
            'error'
          );
          this.savingData = false;
        } else {
          //if(!this.savingData){
            this.savingData = true;
            let previsionAnual;
            if (this.formGroup.get('previsionAnual')?.value) {
              previsionAnual = Number.parseFloat(
                this.formGroup.get('previsionAnual')?.value
              );
            }
            let obj: ResiduoEnvasePayloadDTO = {
              anioDatos: this.formGroup.get('anio')?.value,
              codigoLer: this.formGroup.get('codigoLer')?.value,
              operacionGestion: this.formGroup.get('operacionGestion')?.value,
              nimaGestor: this.formGroup.get('nima')?.value,
              previsionCantidadGenerada: previsionAnual,
              suministradorInformacion: this.formGroup.get('suministraInfo')?.value,
              poseedor: this.data.poseedorInfo,
            };
  
            if(obj.previsionCantidadGenerada && obj.previsionCantidadGenerada > 1000){
              Swal.fire({
                text: 'Por favor, verifique que el valor introducido en la previsión de la cantidad anual generada es correcto y está en las unidades correspondientes (Kg).',
                icon: 'question',
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: 'Guardar',
                denyButtonText: 'Cancelar',
                allowOutsideClick: false,
              }).then((result: any) => {
                if (result.isConfirmed) {
                  this.savingData = false;
                    this.guardarPrevision(obj);
                }else{
                  this.savingData = false;
                }
              });
            } else {
              this.savingData = false;
              this.guardarPrevision(obj);
            }
          //}
          
          
        }
      } 
      } else if (this.data.editar) {
        if(!this.savingData){
        this.savingData = true;
        if(!this.validarDatosNimaPrefijado()){
          this.savingData = false;
          return;
        }
        const existe = this.grid.find(
          (x) =>
            x.anioDatos === this.formGroup.get('anio')?.value &&
            x.codigoLer?.id === this.formGroup.get('codigoLer')?.value?.id &&
            x.operacionGestion?.id ===
              this.formGroup.get('operacionGestion')?.value?.id &&
            x.nimaGestor === this.formGroup.get('nima')?.value &&
            x.previsionCantidadGenerada ==
              this.formGroup.get('previsionAnual')?.value &&
            x.suministradorInformacion ===
              this.formGroup.get('suministraInfo')?.value
        );
        if (existe) {
          this.snackBarSrv.showSnackBar(
            'Ya existe la previsión de residuos de envases introducida',
            'error'
          );
          this.savingData = false;
        } else {
          //if(!this.savingData){
            this.savingData = true;
            let previsionAnual;
            if (this.formGroup.get('previsionAnual')?.value) {
              previsionAnual = Number.parseFloat(
                this.formGroup.get('previsionAnual')?.value
              );
            }
            let obj: ResiduoEnvasePayloadDTO = {
              anioDatos: this.formGroup.get('anio')?.value,
              codigoLer: this.formGroup.get('codigoLer')?.value,
              operacionGestion: this.formGroup.get('operacionGestion')?.value,
              nimaGestor: this.formGroup.get('nima')?.value,
              previsionCantidadGenerada: previsionAnual,
              suministradorInformacion: this.formGroup.get('suministraInfo')?.value,
              poseedor: this.data.poseedorInfo,
            };
  
            if(obj.previsionCantidadGenerada && obj.previsionCantidadGenerada > 1000){
              Swal.fire({
                text: 'Por favor, verifique que el valor introducido en la previsión de la cantidad anual generada es correcto y está en las unidades correspondientes (Kg).',
                icon: 'question',
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: 'Guardar',
                denyButtonText: 'Cancelar',
                allowOutsideClick: false,
              }).then((result: any) => {
                if (result.isConfirmed) {
                  this.editarPrevision(obj);
                }else{
                  this.savingData = false;
                }
              });
            } else {
              this.editarPrevision(obj);
            }
          //}
          
          
        }
      } 
      }

      
    }
    guardarPrevision(residuo: ResiduoEnvasePayloadDTO | any): void {
      this.spinnerSrv.loadingShow();
      this.residuoEnvaseControllerSrv.create3(residuo).subscribe({
        next: (response: PoseedorDTO) => {
          this.savingData = false;
          this.spinnerSrv.loadingHide();
          this.residuoEnvaseControllerSrv
            .comprobarNimaGestor(response.id!)
            .subscribe({
              next: (resultado: any) => {
                residuo.existeNima = resultado;
                if (resultado === false) {
                  let mensaje = 'Este gestor no está registrado en ENVANET. Le recomendamos que le informe de que debe registrarse, en caso de delegarle el suministro de información por la correcta gestión de sus envases.';
                  this.snackBarSrv.showSnackBar(
                    mensaje,
                    'warning'
                  );
                } else {
                 this.snackBarSrv.showSnackBar(
                `Se ha creado correctamente.`,
                'success'
              );
                }
                this.savingData = false;
                this.dialogRef.close(true);
                // No emitir aquí, ya lo hace el padre en el afterClosed
                // Reiniciar formulario 
                this.formGroup.patchValue({
                  codigoLer: null,
                  operacionGestion: null,
                  nima: null,
                  previsionAnual: null,
                  suministraInfo: null,
                });
                this.formGroup.markAsPristine();
                this.formGroup.markAsUntouched();
              },
              error: (error: any) => {
                this.savingData = false;
              },
            });
        },
        error: (err) => {
          this.savingData = false;
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al guardar la previsión de residuos',
            'error'
          );
        },
      });
    }
  
    action(event: any) {
      if (!this.canAccessDelete()) {
        return;
      }
  
      if (event.nameButton == 'delete') {
        this.confirmacionEliminarPrevision(event);
      } 
        
    }
    confirmacionEliminarPrevision(element?: any): void {
      Swal.fire({
        text: `¿Desea eliminar la previsión de residuos?`,
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Sí',
        denyButtonText: 'No',
        allowOutsideClick: false,
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.spinnerSrv.loadingShow();
          this.residuoEnvaseControllerSrv.deleteById3(element.id).subscribe({
            next: (response: PoseedorDTO) => {
              this.spinnerSrv.loadingHide();
              this.refrescarPoseedorEvent.emit(true);
              this.snackBarSrv.showSnackBar(
                `Se ha eliminando correctamente.`,
                'success'
              );
            },
            error: (err) => {
              this.spinnerSrv.loadingHide();
              this.snackBarSrv.showSnackBar(
                'Ha ocurrido un error al eliminar la previsión de residuos',
                'error'
              );
            },
          });
        }
      });
    }
  
    anioSelected(): void {
      if (
        this.data.poseedorInfo?.residuosEnvase &&
        this.data.poseedorInfo?.residuosEnvase?.length > 0
      ) {
        let observables: any[] = [];
  
        let residuosFiltrados = this.data.poseedorInfo?.residuosEnvase.filter(
          (x: any) => x.anioDatos == this.formGroup.get('anio')?.value
        );
        if (residuosFiltrados?.length > 0) {
          residuosFiltrados.forEach((residuo: any) => {
            let observable = this.residuoEnvaseControllerSrv
              .comprobarNimaGestor(residuo.id)
              .pipe(
                map((resultado: any) => {
                  residuo.existeNima = resultado;
                  return residuo;
                }),
                catchError((error: any) => {
                  console.error(
                    `Error comprobando Nima para residuo con id ${residuo.id}:`,
                    error
                  );
                  residuo.existeNima = false;
                  return of(residuo);
                })
              );
            observables.push(observable);
          });
  
          zip(...observables).subscribe((residuosActualizados: any[]) => {
            this.grid = this.canAccessAll(residuosActualizados);
          });
        } else {
          this.grid = [];
        }
      } else {
        this.grid = [];
      }
    }
  
    showWarning(row: any) {
      return !row.existeNima;
    }
  
    canAccessDelete(): boolean {
      return (
        this.authService.can('poseedores-prevision', 'delete') &&
        this.data.poseedorInfo?.estado?.id !== 5
      );
    }
    canAccessCreate(): boolean {
      return (
        this.authService.can('poseedores-prevision', 'create') &&
        this.data.poseedorInfo?.estado?.id !== 5
      );
    }
  
    canAccessAll(list: any) {
      const resultDelete = this.canAccessDelete();
  
      const listPermission = list.map((objeto: any) => {
        let descripcionMCodLer =
          objeto.codigoLer.tipoCodigo + ' ' + objeto.codigoLer.descripcion;
          let operacionMGestion = (objeto.operacionGestion ? objeto.operacionGestion?.codigo +
            ' ' +
            objeto.operacionGestion?.descripcion : '')
        return {
          ...objeto,
          operacionMGestion: operacionMGestion,
          descripcionMCodLer: descripcionMCodLer,
          canAccessDelete: resultDelete,
        };
      });
  
      return listPermission;
    }
  
    finalizar() {
      if (this.grid?.length > 0) {
        this.spinnerSrv.loadingShow();
        this.poseedorControllerSrv
          .finalizarDetalle(this.data!.poseedorInfo!.id!)
          .subscribe({
            next: (response: PoseedorDTO) => {
              this.spinnerSrv.loadingHide();
              this.snackBarSrv.showSnackBar(
                'Proceso finalizado correctamente. Los datos serán revisados por Envalora y, en los próximos días, recibirá un correo electrónico con instrucciones para la firma del acuerdo.',
                'success'
              );
              this.router.navigate(['/initial-page']);
            },
            error: (err) => {
              this.spinnerSrv.loadingHide();
              this.snackBarSrv.showSnackBar(
                'Ha ocurrido un error al finalizar.',
                'error'
              );
            },
          });
      } else {
        this.snackBarSrv.showSnackBar(
          'Es necesario informar de, al menos, una previsión de residuos de envases para el año en curso',
          'error'
        );
      }
    }
  
    validarDatosNimaPrefijado(){
      if (this.data!.poseedorInfo!.nima === this.nimaAsignadoEnvalora) {
        //No puede registrar previsiones con códigos LER 15 01 10 o 15 01 11.
        if (this.formGroup.get('codigoLer')?.value.tipoCodigo == '15 01 10' || this.formGroup.get('codigoLer')?.value.tipoCodigo == '15 01 10*'
          || this.formGroup.get('codigoLer')?.value.tipoCodigo == '15 01 11' || this.formGroup.get('codigoLer')?.value.tipoCodigo == '15 01 11*') {
          this.snackBarSrv.showSnackBar(
            `Si el NIMA del poseedor es ${this.nimaAsignadoEnvalora} no puede registrar previsiones con códigos LER  15 01 10 o 15 01 11.`,
            'error'
          );
          return false;
        }
        //No puede superar previsiones anuales de 1.000 t/año.
        let previsionAnual = 0;
        if (this.formGroup.get('previsionAnual')?.value) {
          previsionAnual = Number.parseFloat(this.formGroup.get('previsionAnual')?.value);
        }
        //Sumar el resto de previsiones existentes para el año seleccionado
        let residuosFiltrados = this.data!.poseedorInfo!.residuosEnvase!.filter(
          (x: any) => x.anioDatos == this.formGroup.get('anio')?.value
        );
        if (residuosFiltrados?.length > 0) {
          residuosFiltrados.forEach((residuo: any) => {
            previsionAnual += residuo.previsionCantidadGenerada;
          });
        }
        
        if(previsionAnual > 1000000){
          this.snackBarSrv.showSnackBar(
            `Si el NIMA del poseedor es ${this.nimaAsignadoEnvalora} no puede superar previsiones anuales de 1.000 t/año.`,
            'error'
          );
          return false;
        }
  
      }
  
      return true;
    }
  
    onInput(controlName: string, event: any) {
      const control = this.formGroup.get(controlName)
      const input = event.target as HTMLInputElement;
      control?.markAsTouched();
      control?.markAsDirty();
    }
    canViewResource(rol: string): boolean {
      return this.authService.hasCurrentUserRole(rol);
    }
    closeDialog() {
        this.dialogRef.close();
    }

    editarPrevision(residuo: ResiduoEnvasePayloadDTO | any): void {
      this.spinnerSrv.loadingShow();
      let residuoEditar: ResiduoEnvasePayloadDTO = {
        anioDatos:residuo.anioDatos,
        codigoLer: residuo.codigoLer,
        operacionGestion: residuo.operacionGestion,
        previsionCantidadGenerada: residuo.previsionCantidadGenerada,
        nimaGestor: residuo.nimaGestor,
        suministradorInformacion: residuo.suministradorInformacion,
        poseedor: residuo.poseedor,
      }
      this.residuoEnvaseControllerSrv.editById2(this.data.prevision.id, residuoEditar).subscribe({
        next: (response: PoseedorDTO) => {
          this.savingData = false;
          this.spinnerSrv.loadingHide();
          this.residuoEnvaseControllerSrv
            .comprobarNimaGestor(response.id!)
            .subscribe({
              next: (resultado: any) => {
                residuo.existeNima = resultado;
                if (resultado === false) {
                  let mensaje = 'Este gestor no está registrado en ENVANET. Le recomendamos que le informe de que debe registrarse, en caso de delegarle el suministro de información por la correcta gestión de sus envases.';
                  this.snackBarSrv.showSnackBar(
                    mensaje,
                    'warning'
                  );
                } else {
                this.snackBarSrv.showSnackBar(
                `Se ha editado correctamente.`,
                'success'
              );
                }
                this.dialogRef.close(true);
                // No emitir aquí, ya lo hace el padre en el afterClosed
                //Reiniciar formulario 
                this.formGroup.patchValue({
                  codigoLer: null,
                  operacionGestion: null,
                  nima: null,
                  previsionAnual: null,
                  suministraInfo: null,
                });
                this.formGroup.markAsPristine();
                this.formGroup.markAsUntouched();
              },
              error: (error: any) => {},
            });
        },
        error: (err) => {
          this.savingData = false;
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al guardar la previsión de residuos',
            'error'
          );
        },
      });
    }
}